/**
 * Customer shown on order detail: persisted Nop snapshot, else ByChef user.
 */
export const resolveOrderCustomer = (order) => {
    const externalUser = order?.externalUser;
    const userDto = order?.userDto;
    const fullName = (externalUser?.fullName || userDto?.fullName || "").trim();
    const phone = (externalUser?.phoneNumber || order?.receiverPhoneNumber || "").trim();
    const companyName = (externalUser?.companyName || order?.companyName || "").trim();
    return {
        fullName,
        phone,
        companyName,
        isExternalSnapshot: Boolean(externalUser),
    };
};
